import { useContext, useEffect } from "react";
import { Helmet } from "react-helmet";
import { AboutUsSection } from "../components/AboutUs";
import { AppContext } from "../context/AppContext"; // importa il contesto
import { useNavigate, useParams } from "react-router-dom";
import { NewsSection } from "../components/News";
import { EventsSection } from "../components/UpcomingEvents";
import { PublicationsSection } from "../components/Publications";
import { GallerySection } from "../components/Gallery";
import { NewsItem, EventItem, PublicationItem, GalleryItem } from "../models/models";
import { SCNavbar } from "../components/Navbar";
import MainSections from "../components/Sections";

export const HomePage = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("AppContext must be used within an AppProvider");
  }
  const { state, updateScientificCommittee } = context;
  const { scientificCommittee } = useParams<{ scientificCommittee: string }>();

  const { data } = state;

  const title = data?.scientific_committee?.name || "ICOH Scientific Committee";
  const description = data?.scientific_committee?.description || "ICOH Scientific Committee";
  const keywords = data?.scientific_committee?.keywords || "ICOH, scientific committee, occupational health";
  const canonical = data?.scientific_committee?.canonical || "https://www.icohweb.org/sc/";

  const navigate = useNavigate();

  useEffect(() => {
    if (scientificCommittee) updateScientificCommittee(scientificCommittee);
  }, [scientificCommittee, updateScientificCommittee]);

  const goToSelectedItem = (item: NewsItem | PublicationItem | EventItem | GalleryItem | null) => {
    if (!item) return;
    navigate(`/${scientificCommittee}/${item.type}/${item.id}`);
  };

  const gotToPastEventsPage = () => {
    navigate(`/${scientificCommittee}/past-events`);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>{title} | ICOH - International Commission on Occupational Health</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link rel="canonical" href={canonical} />
      </Helmet>
      <div className="relative">
        <SCNavbar scientificCommittee={scientificCommittee} />
        <AboutUsSection data={data?.about_us} />
        <MainSections sections={data?.sections} />
        <NewsSection data={data?.news} handleOnClick={goToSelectedItem} />
        <EventsSection data={data?.events} handleOnClick={goToSelectedItem} handleOnClickPastEvents={gotToPastEventsPage}  />
        <PublicationsSection data={data?.publications} handleOnClick={goToSelectedItem} />
        <GallerySection data={data?.gallery} handleOnClick={goToSelectedItem}/>
      </div>
    </>
  );
};

export default HomePage;
